import React, { useEffect, useState } from "react";
import { firestore } from "../firebase.config"; // Ensure correct Firebase import
import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { Helmet } from "react-helmet";
import Sidebar from "./Sidebar";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

const ViewEnquire = () => {
  const [enquiries, setEnquiries] = useState([]);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  
  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };

  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, "PartnerEnquire"));
        const enquiryList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setEnquiries(enquiryList);
      } catch (error) {
        console.error("Error fetching enquiries:", error);
      }
    };

    fetchEnquiries();
  }, []);
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(firestore, "PartnerEnquire", id));
      setEnquiries(enquiries.filter((enquiry) => enquiry.id !== id));
      toast.success("Enquiry deleted successfully!");
    } catch (error) {
      console.error("Error deleting enquiry:", error);
      toast.error("Failed to delete enquiry.");
    }
  };

  return (
    <div className='lg:flex h-2000 overflow-hidden mt-16'>
          <Helmet>
          <title>View Partner Enquire - Admin Panel</title>
          <meta name="description" content="View Partner Enquire details." />
        </Helmet>
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
    
        <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 
          ${isSidebarOpen ? "ml-56 p-2 mr-[-12px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}  
        >
    <div className="p-2">
      <h2 className="lg:text-2xl text-md font-semibold mb-4">Partner Enquiry Details</h2>

      <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300 rounded-md shadow-sm text-sm">
          <thead>
          <tr className="bg-gray-100 border-b border-gray-300">
              <th className="py-2 px-4 text-left">First Name</th>
              <th className="py-2 px-4 text-left">Last Name</th>
              <th className="py-2 px-4 text-left">Email</th>
              <th className="py-2 px-4 text-left">Phone</th>
              <th className="py-2 px-4 text-left">Company Name</th>
              <th className="py-2 px-4 text-left">City</th>
              <th className="py-2 px-4 text-left">State</th>
              <th className="py-2 px-4 text-left">Selling IT</th>
              <th className="py-2 px-4 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {enquiries.length > 0 ? (
              enquiries.map((enquiry) => (
                <tr key={enquiry.id} className="border-b border-gray-300 hover:bg-gray-50">
                  <td className="py-2 px-4">{enquiry.firstName}</td>
                  <td className="py-2 px-4">{enquiry.lastName}</td>
                  <td className="py-2 px-4">{enquiry.email}</td>
                  <td className="py-2 px-4">{enquiry.phone}</td>
                  <td className="py-2 px-4">{enquiry.companyName}</td>
                  <td className="py-2 px-4">{enquiry.city}</td>
                  <td className="py-2 px-4">{enquiry.state}</td>
                  <td className="py-2 px-4">{enquiry.sellingIT}</td>
                  <td className="py-2 px-4 flex space-x-2">
                                          <button className="text-red-500 hover:text-red-700 transition-colors duration-200" onClick={() => handleDelete(enquiry.id)} title="Delete User">
                                            <FaTrash size={13} />
                                          </button>
                                        </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="p-3 text-center text-gray-500">
                  No enquiries found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    </div>
    </div>
  );
};

export default ViewEnquire;
